import React from 'react';
import { withRouter } from "react-router-dom";
import { Divider, LinkList, Typography } from "../../ecosystem";

const DrawerProxySection = ({
    heading,
    children,
    userList
}) => {

    return ((userList && userList.length > 0) || children &&
        <div className="drawer-proxy-section">
            <Typography type="body-01" color="$color-secondary-a2">{heading}</Typography>
            <LinkList>
                {children
                    ? children
                    : userList && userList.map((item, index) => {
                        return (<React.Fragment key={index}>
                            {item}
                            {index !== (userList.length - 1) && <Divider mTop="xsmall" mBottom="xsmall" mHorizontal="none" />}
                        </React.Fragment>)
                    })
                }
            </LinkList>
        </div>
    );
}

export default withRouter(DrawerProxySection);
